// @flow

import { API_CALL } from '../constants/actionTypes';
import { RAPIDFIRE_UPCOMING, RAPIDFIRE_LIVE } from '../constants/apiTypes';
import * as rapidfireApi from '../api/rapidfire';

export function getUpcoming() {
  const query = {
    embed: ['current_user_entry', 'games.teams', 'games.players']
  };
  return {
    type: API_CALL,
    api: RAPIDFIRE_UPCOMING,
    request: rapidfireApi.getUpcoming(query)
  };
}

export function getLive() {
  return {
    type: API_CALL,
    api: RAPIDFIRE_LIVE,
    request: rapidfireApi.getLive()
  };
}
